import React, {useState} from "react";
import Autocomplete from "react-google-autocomplete";
import classnames from "classnames";
import {buildLocationString, parseGoogleAddressData} from "../utils/utils";
import Button from "react-bootstrap/Button";
import CircularProgress from "@mui/joy/CircularProgress";
import AddIcon from '@mui/icons-material/Add';

export const CreateLocationInput = ( { onSave, isSaving } ) => {
    const [addressState, setAddressState] = useState(null)
    const [inputValue, setInputValue] = useState('')

    const saveAddress = () => {
        onSave(addressState)
        setAddressState(null)
    }

    return (
        <div className={'CreateLocationInput'}>
            <Autocomplete
                placeholder={`Enter zipcode`}
                className={classnames('CreateLocationInput_input', {
                    disabled: !addressState
                })}
                style={{zIndex: "inherit"}}
                inputAutocompleteValue={addressState}
                apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onPlaceSelected={(place) => {
                    const parsed = parseGoogleAddressData(place.address_components)
                    setInputValue(buildLocationString(parsed))
                    setAddressState(parsed)
                }}
                options={{
                    types: ['postal_code'], // Restrict suggestions to postal codes only
                    componentRestrictions: { country: 'us' }, // Restrict to a specific country (e.g., US)
                    fields: ['address_components', 'name'] // Request only necessary data fields to control billing
                }}
            />
            <div>
                <Button
                    className={classnames('CreateLocationInput_button', {
                        disabled: !addressState
                    })}
                    onClick={saveAddress}
                    variant="contained"
                    disabled={!addressState}
                >
                    {
                        isSaving ? <CircularProgress variant="soft" size={'sm'}/> : <AddIcon variant="soft" size={'sm'} />
                    }
                    Add Location
                </Button>
            </div>
        </div>
    )
}